import React, { useState } from 'react';
import styled from 'styled-components';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import IconCamera from '../../static/images/products/camera-icon.svg';
import IconPotti from '../../static/images/products/gigapotti-red.svg';
import Icon4G from '../../static/images/products/icon_4g_sim.svg';
import Icon5G from '../../static/images/products/icon_reilu5g_red.svg';
import CheckIcon from '../../static/images/icon_ok_red_new.svg';
import SwipeableViews from 'react-swipeable-views';
import { Product } from '../../model/Products';
import {getCardDisplayName, getSellingPoints} from './productInfo';

interface Props {
	products: Product[];
}

export const B2B2ProductCard: React.FC<Props> = (props: Props) => {
	const selectedIndex = 0;
	const [currentTab, setCurrentTab] = useState(selectedIndex > 0 ? selectedIndex : 0);

	const getEuros = (price: string) => {
		return price.split('.')[0];
	}

	const getCents = (price: string) => {
		let cents = price.split('.')[1]
		if (!cents || !cents.length) cents = '00'
		if (cents.length === 1) cents += '0'

		return cents;
	}

	const getProductIcon = (packageType: string) => {
		if (!packageType) return '';
		if (["B2B_PACK_5G_400_4G_DISCOUNT", "B2B_PACK_5G_1000_4G_DISCOUNT"].includes(packageType)) {
			return <img src={Icon5G} className="product-icon" alt="Icon" style={{height: "66px"}} />;
		} else if (packageType === "B2B_PACK_4G_BASIC_MOIPOT") {
			return <img src={Icon4G} className="product-icon" alt="Icon" style={{height: "62px"}} />;
		} else if (packageType === "B2B_PACK_4G_UNLIMITED") {
			return <img src={IconPotti} className="product-icon" alt="Icon" style={{height: "62px"}} />;
		} else if (packageType === "B2B_PACK_M2M") {
			return <img src={IconCamera} className="product-icon" alt="Icon" style={{height: "60px"}} />;
		}
	}

	return (
		<StackWrapper className="has-tabs">
			<Tabs
				className="tabs-container"
				selectedIndex={currentTab}
				onSelect={(index) => {
					setCurrentTab(index);
				}}
			>
				<TabList>
					{props.products.map((product: Product) => (
						<Tab className="tab-numbers" selectedClassName="selected" key={product.orderItemCode}>
							<span className={'tab-title'} onClick={(event) => event.preventDefault()}>
								<span>{product.dataSpeedMbs} Mbit</span>
							</span>
						</Tab>
					))}
				</TabList>
				<SwipeableViews index={currentTab} onChangeIndex={(index) => setCurrentTab(index)}>
					{props.products.map((product: Product) => (
						<TabPanel forceRender={true} key={product.orderItemCode}>
							<Card>
								<h3>{getCardDisplayName(product.orderItemCode)}</h3>
								<PriceRow>
									{product.maxEurPerMonth ?
										<PriceTagWrapper className="price-tag">
											<div className="price-tag-price">{getEuros(product.eurPerMonth.toString())}-{product.maxEurPerMonth}</div>
											<div className="price-tag-unit-block">
												<span className="price-tag-unit">€</span>
												<span className="price-tag-price-per">/kk</span>
											</div>
										</PriceTagWrapper>
										:
										<PriceTagWrapper className="price-tag">
											<div className="price-tag-price">{getEuros(product.eurPerMonth.toString())}</div>
											<div className="price-tag-unit-block">
												<span className="price-tag-unit">{getCents(product.eurPerMonth.toString())}</span>
												<span className="price-tag-price-per">€/kk</span>
											</div>

											{getProductIcon(product.orderItemCode)}
										</PriceTagWrapper>
									}

								</PriceRow>
								<ProductDetails>
									<SellingPoints>
										{getSellingPoints(product.orderItemCode).map((item: any, index) => (
											<li className={index === 0 ? "sellingpoints-raise" : ""} key={index}>
												<span className="icon-wrapper">
													{index > 0 && <img src={CheckIcon} className="icon-check-black" alt="Icon" />}
												</span>
												{item}
											</li>
										))}
									</SellingPoints>
								</ProductDetails>
							</Card>
						</TabPanel>
					))}

				</SwipeableViews>
			</Tabs>
		</StackWrapper>
	);
};

const Card = styled.div`
	position: relative;
	padding: 15px 21px 31px 21px;
	min-width: 13.5rem;
	text-align: center;
	font-size: 1.3rem;
	color: #4c4c4c;

	@media screen and (max-width: 1000px) {
		padding: 18px 0.8rem 18px;
	}

	@media screen and (max-width: 700px) {
		padding: 14px 0.8rem 18px;
		max-width: 100%;
	}

	* {
		z-index: 1;
	}

	h3 {
		font-size: 50px;
		color: #4c4c4c;
		font-weight: 300;
		margin: 0;
		line-height: 1;

		@media screen and (max-width: 700px) {
			font-size: 35px;
		}
	}
`;

const PriceRow = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	font-weight: 300;

	@media screen and (min-height: 701px) and (max-width: 1024px) {
		max-height: 76px;
		margin-top: 12px;
	}

	.price-tag {
		margin-top: 15px;
		@media screen and (max-width: 700px) {
			margin-top: 4px;
		}
	}

	.product-icon {
		vertical-align: middle;
		margin-left: 10px;
		margin-top: -3px;
		
		@media screen and (min-width: 800px) {
			margin-top: -5px;
		}
	}
`;

const ProductDetails = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
`;

const SellingPoints = styled.ul`
	display: flex;
	flex-direction: column;
	font-size: 16px;
	color: #4c4c4c;
	text-align: left;
	line-height: 1;
	list-style-type: none;
	margin: 10px 0 0;
	padding: 0;

	.sellingpoints-raise {
		text-align: center;
		justify-content: center;
		font-size: 25px;
		line-height: 1.1;
		margin-bottom: 15px;


		@media screen and (max-width: 700px)  {
			font-size: 21px;
			margin-bottom: 10px;
		}
	}

	li {
		display: flex;
		flex-direction: row;
		margin-bottom: 5px;
		align-items: flex-start;
		font-size: 16px;
		line-height: 1.2;

		.icon-wrapper {
			display: flex;
			padding-right: 4px;
			align-items: flex-start;
			justify-content: flex-end;
		}
	}

	.icon-check-black {
		width: 17px;
		min-width: 17px;
		height: 17px;
		margin: 0 5px 0 10px;
	}

	@media screen and (max-width: 700px)  {
		margin: 0;
	}
`;

const PriceTagWrapper = styled.div`
	padding: 0;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;
	max-height: 96px;

	.price-tag-price {
		font-size: 102px;
		display: flex;
		align-items: center;
		line-height: 1;
		white-space: nowrap;
		font-weight: 300;
		font-family: "Platform", Arial, sans-serif;

		@media screen and (max-width: 700px) {
			font-size: 79px;
			min-height: 0;
		}
	}

	.price-tag-unit-block {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-end;
		padding: 0 0 4px 4px;
	}

	.price-tag-unit {
		font-size: 56px;
		padding-bottom: 9px;
		line-height: 40px;

		@media screen and (max-width: 700px) {
			font-size: 43px;
			padding-bottom: 2px;
		}
	}

	.price-tag-price-per {
		font-size: 26px;
		line-height: 20px;
		letter-spacing: normal;

		@media screen and (max-width: 700px) {
			font-size: 19px;
		}
	}
`;

const StackWrapper = styled.div`
	border-radius: 5px;
	max-width: 289px;
	width: 24.35%;
	margin-bottom: 20px;

	&.no-tabs {
		padding-top: 10px;
		.react-tabs__tab-list {
			min-height: 43px;
		}
	}

	.product-tablist {
		border-radius: 0 0 8px 8px;
	}

	@media screen and (max-width: 1300px) {
		max-width: 400px;
		width: 100%;
		//margin-bottom: 10px;
	}

	@media screen and (max-width: 700px) {
		//margin-bottom: 30px;
		&.no-tabs {
			.react-tabs__tab-list {
				display: none;
			}

			.product-tablist {
				border-radius: 8px;
			}
		}
	}

	.tabs-container {
		box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.16);
		border-radius: 30px;
		overflow: hidden;
		height: 100%;

		.react-tabs__tab-list {
			padding: 0;
		}
	}

	@media screen and (max-width: 799px) {
		min-width: 280px;
		max-width: 420px;

		.no-tabs .react-tabs__tab-panel {
			margin-top: -50px !important;
		}
	}

	.no-tabs {
		.product-card {
			padding-top: 0;
		}
	}

	.react-tabs__tab-list {
		list-style-type: none;
		display: flex;
		flex-wrap: nowrap;
		font-size: 1rem;
		background: rgb(240, 240, 240);
		margin: 0;
		justify-content: space-around;
		min-height: 39px;
		border: 0;
		border-radius: 8px 8px 0 0;
	}

	.react-tabs__tab-panel {
		border-radius: 0 0 8px 8px;
		background: #fff;
	}

	.tab-numbers {
		flex-grow: 1;
		padding: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 0;
		cursor: pointer;
		text-align: center;

		&:focus-visible {
			outline: none !important;
		}

		&:first-of-type {
			border-radius: 8px 0 0 0;
			&.selected {
			}
		}

		&:last-of-type {
			border-radius: 0 8px 0 0;
		}

		.tab-title {
			font-size: 24px;
			font-weight: bold;
			color: #4c4c4c;
			margin-bottom: 0;
			line-height: 1.2;
			white-space: nowrap;
			padding: 12px 0;

			&:hover {
				color: #f00;
			}

			@media screen and (max-width: 700px) {
				font-size: 20px;
				padding: 8px 0;
			}
		}
		&.selected {
			background: #fff;
			border-bottom: 0;

			.tab-title {
				display: inline-block;
				color: #f00;
			}
			&.selected-product {
				a {
				}
			}
		}
	}
`;
